import { render, staticRenderFns } from "./EditPersonalInfoDialog.vue?vue&type=template&id=4b987203&scoped=true"
import script from "./EditPersonalInfoDialog.vue?vue&type=script&lang=js"
export * from "./EditPersonalInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalInfoDialog.vue?vue&type=style&index=0&id=4b987203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b987203",
  null
  
)

export default component.exports